import React from 'react';
import { cssMap } from '@compiled/react';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';
import { Box } from '@atlaskit/primitives/compiled';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import { fg } from '@atlassian/jira-feature-gating';
import type BulkActionToolbar from './index.tsx';
import type { Props as BulkActionsToolbarProps } from './index.tsx';

// Match the height of the toolbar
const HEIGHT = 24;

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const AsyncBulkActionToolbarLazy = lazyAfterPaint<typeof BulkActionToolbar>(
	() => import(/* webpackChunkName: "async-servicedesk-bulk-actions-toolbar" */ './index'),
	{ ssr: false },
);

export const AsyncBulkActionToolbar = (props: BulkActionsToolbarProps): React.JSX.Element => (
	<ErrorBoundary
		id="async.jira-servicedesk.bulk-actions.toolbar"
		packageName="atlassian/jira-servicedesk-bulk-actions-toolbar"
	>
		<Placeholder
			name="servicedesk-bulk-actions-toolbar"
			fallback={
				fg('jsm_remove_queue_bulk_action_bar_from_preloading') ? (
					<Box xcss={styles.skeletonContainer}>
						<Skeleton height={`${HEIGHT}px`} width="60vw" isShimmering />
					</Box>
				) : null
			}
		>
			<AsyncBulkActionToolbarLazy {...props} />
		</Placeholder>
	</ErrorBoundary>
);

const styles = cssMap({
	skeletonContainer: {
		width: '100vw',
		backgroundColor: token('elevation.surface'),
		paddingLeft: token('space.100'),
	},
});
